import {
  useHistory
} from "react-router-dom";
import {
  twMerge
} from "tailwind-merge";
import {
  Children,
  Fragment,
  ReactNode,
  createElement,
  isValidElement
} from "react";

import {
  Stack
} from "../../Layouts";
import {
  ContentActionProps
} from "./ContentAction.types";
import {
  Theme
} from "./ContentAction.theme";

function flattenChildren(children: ReactNode): ReactNode[] {
  const result: ReactNode[] = [];
  Children.forEach(children, (child) => {
    if (isValidElement(child) && child.type === Fragment) {
      result.push(...flattenChildren(child.props.children));
    } else if (child !== null && child !== undefined && child !== false) {
      result.push(child);
    }
  });
  return result;
}

export function ContentAction({
  className,
  children,
  hideCancelButton,
  hideSubmitButton,
  mutation,
  loading,
  action,
  form,
  ...props
}: ContentActionProps) {

  const history = useHistory();

  const [cancelEl, submitEl] = flattenChildren(children);

  const isLoading = mutation?.isLoading || loading;

  return (
    <Stack
      className={twMerge(Theme.container, className)}
      direction="row"
      justify="end"
      gap={4}
      {...props}
    >
      {isValidElement(cancelEl) && !hideCancelButton && createElement(cancelEl.type, {
        disabled: isLoading,
        children: "Cancel",
        onClick: () => history.goBack(),
        color: "primary",
        ...cancelEl.props,
        className: twMerge("min-w-[128px]", cancelEl.props?.className),
        variant: "outlined",
      })}
      {isValidElement(submitEl) && !hideSubmitButton && createElement(submitEl.type, {
        children: "Submit",
        onClick: form?.handleSubmit((_) => mutation?.mutate(_)),
        loading: isLoading,
        color: "primary",
        ...submitEl.props,
        className: twMerge("min-w-[128px]", submitEl.props?.className),
        variant: "contained",
      })}
    </Stack>
  );
}
